/**
 * src/hooks/useAdminPanel.js
 * React Query v5 hooks para las vistas de detalle del panel de control.
 */
import { useQuery } from '@tanstack/react-query'
import {
  getActividad, getActividadDia, getFamilias, getSchedulerDetalle, getAlertas,
  getEmbudo, getUso, getUsoAgregado, getUsoCliente, getUsoHorarios,
} from '../api/adminPanel'

export function useActividad(dias) {
  return useQuery({
    queryKey: ['panel', 'actividad', dias],
    queryFn: () => getActividad(dias),
    refetchInterval: 60_000,
  })
}

export function useActividadDia(fecha) {
  return useQuery({
    queryKey: ['panel', 'actividad', 'dia', fecha],
    queryFn: () => getActividadDia(fecha),
    enabled: !!fecha,
  })
}

export function useFamilias() {
  return useQuery({
    queryKey: ['panel', 'familias'],
    queryFn: getFamilias,
  })
}

export function useSchedulerDetalle() {
  return useQuery({
    queryKey: ['panel', 'scheduler'],
    queryFn: getSchedulerDetalle,
    refetchInterval: 60_000,
  })
}

export function useAlertas(params) {
  return useQuery({
    queryKey: ['panel', 'alertas', params],
    queryFn: () => getAlertas(params),
    refetchInterval: 60_000,
  })
}

export function useEmbudo(dias) {
  return useQuery({
    queryKey: ['panel', 'embudo', dias],
    queryFn: () => getEmbudo(dias),
    refetchInterval: 120_000,
  })
}

export function useUso(dias) {
  return useQuery({
    queryKey: ['panel', 'uso', dias],
    queryFn: () => getUso(dias),
    refetchInterval: 120_000,
  })
}

export function useUsoAgregado(dias) {
  return useQuery({
    queryKey: ['panel', 'uso', 'agregado', dias],
    queryFn: () => getUsoAgregado(dias),
    refetchInterval: 120_000,
  })
}

export function useUsoCliente(clienteId, dias) {
  return useQuery({
    queryKey: ['panel', 'uso', 'cliente', clienteId, dias],
    queryFn: () => getUsoCliente(clienteId, dias),
    enabled: !!clienteId,
  })
}

export function useUsoHorarios(dias) {
  return useQuery({
    queryKey: ['panel', 'uso', 'horarios', dias],
    queryFn: () => getUsoHorarios(dias),
    refetchInterval: 120_000,
  })
}
